import { defineComponent as _defineComponent } from 'vue';
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-323acaaa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "StoryMapPanel absolute inset-0 flex flex-col lg:flex-row-reverse justify-end overflow-hidden" };
const _hoisted_2 = { class: "Panel relative text-white over" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Background Background--color absolute inset-0 origin-top-right pointer-events-none" }, null, -1));
const _hoisted_4 = { class: "Background Background--headings absolute inset-x-0 inset-y-0 hidden lg:flex flex-col items-center justify-between *:flex-none font-screamer font-bold leading-screamer pointer-events-none overflow-hidden" };
const _hoisted_5 = { class: "Heading Heading--date" };
const _hoisted_6 = { class: "relative flex justify-center items-center h-full lg:px-container" };
const _hoisted_7 = { class: "grid" };
const _hoisted_8 = { class: "row-start-2 col-start-1 flex justify-center items-center size-0" };
const _hoisted_9 = {
    key: 1,
    class: "row-start-1 col-start-1 self-end relative p-container pointer-events-none"
};
import { computed, ref, toRefs } from "vue";
import { onKeyDown } from "@vueuse/core";
import Viewport from "@/store/modules/Viewport";
import useGSAP from "@/composables/useGSAP";
import { setFPS } from "@/utils/frameToTime";
import AudioManager from "@webgl/core/audio/AudioManager";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoryMapPanel',
    props: {
        title: {},
        description: {},
        image: {},
        video: {},
        date: {},
        place: {},
        caption: {}
    },
    emits: ["prev", "next", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const gsap = useGSAP();
        const frames = setFPS(60);
        const isAppeared = ref(false);
        const { isDesktop, isMobile } = toRefs(Viewport);
        const mediaAspectRatio = computed(() => {
            const { image, video } = props;
            const media = video || image;
            if (!media)
                return "auto";
            const width = (typeof media.width === "string" ? parseInt(media.width) : media.width) || 0;
            const height = (typeof media.height === "string" ? parseInt(media.height) : media.height) || 0;
            return width && height ? width / height : "auto";
        });
        const mediaKey = computed(() => {
            const { image, video } = props;
            if (!(image || video))
                return "";
            if (video)
                return video.src;
            return Array.isArray(image.src) ? image.src[0] : image.src;
        });
        const cardProps = computed(() => (Object.assign(Object.assign({}, props), { image: isMobile.value ? props.image : undefined, video: isMobile.value && props.video ? Object.assign(Object.assign({}, props.video), { autoplay: isAppeared.value }) : undefined, reverse: isMobile.value, folded: isDesktop.value ? "right" : false, delay: isDesktop.value ? frames(60) : 0 })));
        function onEnter(el, onComplete) {
            // @TODO: mobile animation
            if (isMobile.value)
                return onComplete();
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                onComplete,
                defaults: {
                    ease: "ease.out"
                }
            });
            tl
                .from($(".Background--color"), {
                xPercent: -100,
                rotation: 60,
                duration: frames(60),
            }, 0)
                .from($(".Heading"), {
                yPercent: (i) => i ? 100 : -100,
                duration: frames(40),
                stagger: frames(6)
            }, frames(40));
            // Card animation
            (() => {
                const [card] = $(".Card");
                gsap.set(card, { rotation: -20 });
                const { right } = card.getBoundingClientRect();
                const x = -right;
                const y = 192;
                gsap.set(card, { x, y });
                tl.to(card, {
                    motionPath: {
                        path: [{ x: -0.5 * x, y: -0.5 * y }, { x: -0.5 * x, y: -0.5 * y }],
                        relative: true,
                        curviness: 2,
                    },
                    rotation: 0,
                    duration: frames(40),
                    ease: "ease.out"
                }, `<${frames(10)}`);
            })();
            // Media animation
            (() => {
                const [picture] = $(".Media");
                if (!picture)
                    return;
                gsap.set(picture, { rotation: -98 });
                const { right } = picture.getBoundingClientRect();
                gsap.set(picture, { x: -right, y: 192, filter: "brightness(12)" });
                tl.to(picture, {
                    x: 0,
                    y: 0,
                    rotation: 2,
                    filter: "brightness(1)",
                    duration: frames(60),
                    ease: "ease.out"
                }, `<${frames(10)}`);
            })();
        }
        function onAfterEnter(el) {
            isAppeared.value = true;
            const video = el.querySelector("video");
            if (!video)
                return;
            // autoplay video
            video.play();
        }
        function onBeforeLeave(el) {
            // console.log("onbeforeleave")
            const video = el.querySelector("video");
            if (!video)
                return;
            // pause video
            video.pause();
        }
        const SWIPE_SOUNDS = ["UI_ASSET_SWIPE-00", "UI_ASSET_SWIPE-01", "UI_ASSET_SWIPE-02"];
        const playSwipeSound = () => AudioManager.playUI(gsap.utils.random(SWIPE_SOUNDS), 0, 1.0, true);
        const prev = () => {
            playSwipeSound();
            emit("prev");
        };
        const next = () => {
            playSwipeSound();
            emit("next");
        };
        const close = () => {
            AudioManager.playUI("UI_SECONDARY_CLICK");
            emit("close");
        };
        onKeyDown(["ArrowLeft", "PageUp"], (e) => {
            e.preventDefault();
            prev();
        });
        onKeyDown(["ArrowRight", "PageDown"], (e) => {
            e.preventDefault();
            next();
        });
        onKeyDown(["Escape"], close);
        return (_ctx, _cache) => {
            const _component_UICard = _resolveComponent("UICard");
            const _component_UIVideo = _resolveComponent("UIVideo");
            const _component_UIImage = _resolveComponent("UIImage");
            const _component_UIRoundCta = _resolveComponent("UIRoundCta");
            const _component_UIPrevNext = _resolveComponent("UIPrevNext");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createBlock(_Transition, {
                css: false,
                appear: "",
                onEnter: onEnter,
                onAfterEnter: onAfterEnter,
                onBeforeLeave: onBeforeLeave
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _withDirectives(_createElementVNode("div", {
                            class: "Backdrop absolute inset-0",
                            onClick: close
                        }, null, 512), [
                            [
                                _directive_sound,
                                'UI_SECONDARY_CLICK',
                                void 0,
                                { click: true }
                            ]
                        ]),
                        _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.date), 1)
                                ]),
                                _createElementVNode("div", {
                                    class: "Heading Heading--place",
                                    style: _normalizeStyle({ '--length': _ctx.place.length })
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.place), 1)
                                ], 4)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    (_openBlock(), _createBlock(_component_UICard, _mergeProps({
                                        key: _unref(isMobile) ? mediaKey.value : 'card',
                                        class: "Card row-start-1 col-start-1 lg:backface-hidden"
                                    }, cardProps.value), null, 16)),
                                    (_unref(isDesktop))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (props.video || props.image)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: mediaKey.value,
                                                    class: "row-start-2 col-start-2 flex justify-end items-start w-248 -ml-144 -mt-16"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "Media flex-none w-[125%] relative",
                                                        style: _normalizeStyle({ aspectRatio: mediaAspectRatio.value })
                                                    }, [
                                                        (props.video)
                                                            ? (_openBlock(), _createBlock(_component_UIVideo, _mergeProps({ key: 0 }, props.video, { autoplay: isAppeared.value }), null, 16, ["autoplay"]))
                                                            : (_openBlock(), _createBlock(_component_UIImage, _normalizeProps(_mergeProps({ key: 1 }, props.image)), null, 16))
                                                    ], 4)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createVNode(_component_UIRoundCta, {
                                                    text: _ctx.$t('map.hotspot.close'),
                                                    variant: "map",
                                                    delay: _unref(frames)(80),
                                                    sound: "UI_SECONDARY_CLICK",
                                                    onClick: close
                                                }, null, 8, ["text", "delay"])
                                            ])
                                        ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createVNode(_component_UIPrevNext, {
                                                theme: "light",
                                                onPrev: prev,
                                                onNext: next
                                            })
                                        ]))
                                ])
                            ])
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
